import { createSwrListStore } from './swr/createSwrListStore';
import { getCharacters } from '../lib/api';

const swr = createSwrListStore({
  name: 'CharactersStore',
  storageKey: 'bookthing-characters',
  itemsField: 'characters',
  setters: {
    set: 'setCharacters',
    add: 'addCharacter',
    update: 'updateCharacter',
    remove: 'deleteCharacter',
    reset: 'resetCharacters',
  },
  fetcher: async () => {
    const resp = await getCharacters();
    return resp.characters || [];
  },
});

export const useCharactersStore = swr.useStore;
export const useCharactersData = swr.useData;
export const fetchCharactersIfStale = swr.fetchIfStale;
